import {BaseApiService} from "../../../infrastructure/domain-services/base-api-service";
import {StandingsFactory} from "./standings.factory";
import {BaseUtilsService} from "../../../infrastructure/domain-services/base-utils-service";

export class StandingsApi extends BaseApiService {
  static injectables = [...BaseUtilsService.injectables, StandingsFactory];
}
